module.exports = __webpack_public_path__ + "static/media/spot.8ccadb58.svg";